import React, { useRef } from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import testimonial from "../assets/img/testimonial/carman.png"
import testimonial1 from "../assets/img/testimonial/pk.jpeg"
import testimonial2 from "../assets/img/testimonial/DKahenya.jpeg"
import testimonial3 from "../assets/img/testimonial/tf.jpg"

import CaseStudyGallery from '../components/CaseStudyGallery';
import { FaPalette } from "react-icons/fa";       // For Website Design
import { FaCode } from "react-icons/fa";          // For Website Development
import { FaShoppingCart } from "react-icons/fa";  // For Online Store
import { FaCalendarCheck } from "react-icons/fa"; // For Booking Systems (optional)
import LocalTimeWithLocation from '../components/NairobiTime';
import { TbNorthStar } from "react-icons/tb";
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import { useMediaQuery } from 'react-responsive';
import WebsiteFAQs from '../components/WebsiteFaqs';

const Website = () => {

  const isDesktop = useMediaQuery({minWidth: 768})
 
useEffect(() => {
  gsap.registerPlugin(ScrollTrigger);

  const lenis = new Lenis();
  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  const smoothStep = (p) => p * p * (3 - 2 * p);

  // Example: Hero animation
  ScrollTrigger.create({
    trigger: ".hero",
    start: "top top",
    end: "75% top",
    scrub: 1,
    onUpdate: (self) => {
      const progress = self.progress;
    const isDesktop = window.innerWidth >= 1024; // adjust breakpoint as needed
    const opacityStart = isDesktop ? 3 : 1;

    const heroCardContainerOpacity = gsap.utils.interpolate(
      opacityStart,
      0,
      smoothStep(progress)
    );
      gsap.set(".hero-cards", { opacity: heroCardContainerOpacity });

      ["#hero-card-1", "#hero-card-2", "#hero-card-3"].forEach((cardId, index) => {
        const delay = index * 0.9;
        const cardProgress = gsap.utils.clamp(
          0,
          1,
          (progress - delay * 0.1) / (1 - delay * 0.1)
        );

        const y = gsap.utils.interpolate("0%", "250%", smoothStep(cardProgress));
        const scale = gsap.utils.interpolate(1, 0.75, smoothStep(cardProgress));

        let x = "0%";
        let rotation = 0;

        if (index === 0) {
          x = gsap.utils.interpolate("0%", "90%", smoothStep(cardProgress));
          rotation = gsap.utils.interpolate(0, -15, smoothStep(cardProgress));
        } else if (index === 2) {
          x = gsap.utils.interpolate("0%", "-90%", smoothStep(cardProgress));
          rotation = gsap.utils.interpolate(0, 15, smoothStep(cardProgress));
        }

        gsap.set(cardId, { y, x, rotation, scale });
      });
    },
  });


    ScrollTrigger.create({
      trigger: ".services",
      start: "top top",
      end: `+=${window.innerHeight * 1}px`,
      pin: ".services",
      pinSpacing: true,
    });

    ScrollTrigger.create({
      trigger: ".services",
      start: "top top",
      end: `+=${window.innerHeight * 1}px`,
      onLeave: () => {
        const servicesSection = document.querySelector(".services");
        if (!servicesSection) return;
        const servicesRect = servicesSection.getBoundingClientRect();
        const servicesTop = window.pageYOffset + servicesRect.top;
        gsap.set(".cards", {
          position: "absolute",
          top: servicesTop,
          left: 0,
          width: "100vw",
          height: "100vh",
        });
      },
      onEnterBack: () => {
        gsap.set(".cards", {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
        });
      },
    });

    ScrollTrigger.create({
      trigger: ".services",
      start: "top bottom",
      end: `+=${window.innerHeight * 2}px`,
      scrub: 1,
      onUpdate: (self) => {
        const progress = self.progress;
  
        ["#card-1", "#card-2", "#card-3"].forEach((cardId, index) => {
          const delay = index * 0.5;
          const cardProgress = gsap.utils.clamp(
            0,
            1,
            (progress - delay * 0.1) / (0.9 - delay * 0.1)
          );

          const card = document.querySelector(cardId);
          const innerCard = card?.querySelector(".flip-card-inner");

          let y;
          if (cardProgress < 0.4) {
            const normalized = cardProgress / 0.4;
            y = gsap.utils.interpolate("-100%", "50%", smoothStep(normalized));
          } else if (cardProgress < 0.6) {
            const normalized = (cardProgress - 0.4) / 0.2;
            y = gsap.utils.interpolate("50%", "0%", smoothStep(normalized));
          } else {
            y = "0%";
          }

          let scale;
          if (cardProgress < 0.4) {
            const normalized = cardProgress / 0.4;
            scale = gsap.utils.interpolate(0.25, 0.75, smoothStep(normalized));
          } else if (cardProgress < 0.6) {
            const normalized = (cardProgress - 0.4) / 0.2;
            scale = gsap.utils.interpolate(0.75, 1, smoothStep(normalized));
          } else {
            scale = 1;
          }

          let x, rotate, rotationY;
          if (cardProgress < 0.6) {
            x = index === 0 ? "100%" : index === 1 ? "0%" : "-100%";
            rotate = index === 0 ? -5 : index === 1 ? 0 : 5;
            rotationY = 0;
          } else if (cardProgress < 1) {
            const normalized = (cardProgress - 0.6) / 0.4;
            x = gsap.utils.interpolate(
              index === 0 ? "100%" : index === 1 ? "0%" : "-100%",
              "0%",
              smoothStep(normalized)
            );
            rotate = gsap.utils.interpolate(
              index === 0 ? -5 : index === 1 ? 0 : 5,
              0,
              smoothStep(normalized)
            );
            rotationY = smoothStep(normalized) * 180;
          } else {
            x = "0%";
            rotate = 0;
            rotationY = 180;
          }

          gsap.set(cardId, { opacity: 1, y, x, rotate, scale });
          if (innerCard) {
            gsap.set(innerCard, { rotationY });
          }
        });
      },
    });
  return () => {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    gsap.ticker.remove((time) => {
      lenis.raf(time * 1000);
    });
    lenis.destroy();
  };
}, [isDesktop])


    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }
  

     const servicesRef = useRef(null);
        
     useEffect (() => {
      const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
       const scrollReveal = () => {
          for (let i = 0; i < revealElements.length; i++) {
           const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
        
        if (elementIsInScreen) {
         revealElements[i].classList.add("revealed");
         } else {
            revealElements[i].classList.remove("revealed");
             }
          }
         };
        
         window.addEventListener("scroll", scrollReveal);
            scrollReveal(); // Initial check
        
            return () => {
              window.removeEventListener("scroll", scrollReveal);
            };
          }, []);
  

  return (
    <>
<section className="website-wrapper  website" ref={servicesRef}>
    

 <Nav/>

  <section className="hero">
    <div className='hero__col-1'>
    <div className='hero__top-strip'>
        <div>
           <TbNorthStar className="star-icon"/>
            <TbNorthStar className="star-icon"/>
        </div>
        <div>
           <TbNorthStar className="star-icon"/>
           
            <TbNorthStar className="star-icon"/>
        </div>
    </div>
    <div className='hero-header'>
      <span>Roarz</span>
       <span>Kreatives</span>
         
      </div> 
    </div>

<div className="hero-cards">

  {/* Card 1: Website Design */}
  <div className="card" id="hero-card-1">
    <div className="card-title">
      <span>Website Design</span>
      <span>01</span>
    </div>
    <div className='icon-container'>
      <FaPalette className='card-icon' />
    </div>
    <div className="card-title">
      <span>Website Design</span>
      <span>01</span>
    </div>
  </div>

  {/* Card 2: Website Development */}
  <div className="card" id="hero-card-2">
    <div className="card-title">
      <span>Website Development</span>
      <span>02</span>
    </div>
    <div className='icon-container'>
      <FaCode className='card-icon' />
    </div>
    <div className="card-title">
      <span>Website Development</span>
      <span>02</span>
    </div>
  </div>

  {/* Card 3: Online Store & Booking Systems */}
  <div className="card" id="hero-card-3">
    <div className="card-title">
      <span>Online Store & Booking Systems</span>
      <span>03</span>
    </div>
    <div className='icon-container'>
      <FaShoppingCart className='card-icon' />
      </div>
    <div className="card-title store-card">
      <span>Online Store & Booking Systems</span>
      <span>03</span>
    </div>
  </div>

</div>

  <div className='hero__col-2'> 
<div className='hero__left-col'>
  <div>
    <span>UI/UX Designers &</span>
    <span>Developers</span>
  </div>

  <p>We are a team of web designers and developers, creating websites that reflect the latest technologies and trends while prioritizing performance, stability, and user experience.</p>
</div>

    <div className='hero__right-col'>
      <p>Plan</p>
      <p>Design</p>
      <p>Develop</p>
    </div>
  </div>

  </section>

  <section className="about">
    <div className="corners">
      <div className="corner-1"></div>
      <div className="corner-2"></div>
    </div>    
     
   <div className="about__content">

    <h1 data-reveal>What you can expect from us: </h1>
<p data-reveal>
Roarz Kreatives is a forward-thinking web development agency that empowers businesses to thrive in the digital age. With a blend of creativity, strategy, and cutting-edge technology, we specialize in crafting innovative digital products, brands, and applications that drive results. Whether you're a startup or an established enterprise, we’re here to help you shape the future, one project at a time.
</p>
  

   <div className="about__content-2">
    <div className="qoute__container">
    
      <p data-reveal="left">
        Every website we create is designed to tell your story clearly, engage your audience deeply, and turn attention into action.
       </p>
     </div>

              <div className="community-badge" data-reveal="right">
          <svg viewBox="0 0 200 200" className="badge-svg">
            <defs>
              <path
                id="circlePath"
                d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
              />
            </defs>
            <text fontSize="19" fill="#fff">
              <textPath href="#circlePath" startOffset="0%">
                • CREATIVITY • PERFORMANCE • USER EXPERIENCE •
              </textPath>
            </text>
          </svg>
          <div className="badge-star">★</div>
        </div>
   </div>
   </div>

   

       <div className="corners__bottom">
      <div className="corner__bottom-1"></div>
      <div className="corner__bottom-2"></div>
    </div>
</section>


  {isDesktop ? (
    <>
  <section className="services">
    
  </section>  
    <section className="cards">
      <div className="cards-header">
      <h1>Services</h1>
    </div>
<div className="cards-container">

  {/* Card 1: Website Design */}
  <div className="card" id="card-1">
    <div className="card-wrapper">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="card-title">
            <span>Website Design</span>
            <span>01</span>
          </div>
              <div className='icon-container'>
      <FaPalette className='card-icon' />
      </div>
                <div className="card-title card__bottom-title">
           <span>01</span>
            <span>Website Design</span>
            
          </div>
        </div>
        <div className="flip-card-back">
          <div className="card-title">
            <span>Website Design</span>
            <span>01</span>
          </div>
          <div className="card-copy">
            <p>UI/UX Design</p>
            <p>Responsive Layouts</p>
            <p>Wireframes & Prototypes</p>
            <p>Branding Integration</p>
            <p>Visual Storytelling</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Card 2: Website Development */}
  <div className="card" id="card-2">
    <div className="card-wrapper">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="card-title">
            <span>Website Development</span>
            <span>02</span>
          </div>
    <div className='icon-container'>
      <FaCode className='card-icon' />
    </div>          
           <div className="card-title">
            <span>02</span>           
            <span>Website Development</span>

          </div>
        </div>
        <div className="flip-card-back">
          <div className="card-title">
            <span>Website Development</span>
            <span>02</span>
          </div>
          <div className="card-copy">
            <p>Frontend Coding</p>
            <p>Backend Development</p>
            <p>CMS Integration</p>
            <p>SEO Optimization</p>
            <p>Performance Tuning</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Card 3: Online Store & Booking Systems */}
  <div className="card" id="card-3">
    <div className="card-wrapper">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="card-title">
            <span>Online Store & Booking Systems</span>
            <span>03</span>
          </div>
              <div className='icon-container'>
      <FaShoppingCart className='card-icon' />
      </div>
             <div className="card-title">
            <span>03</span>              
            <span>Online Store & Booking Systems</span>

          </div>
        </div>
        <div className="flip-card-back">
          <div className="card-title">
            <span>Online Store & Booking Systems</span>
            <span>03</span>
          </div>
          <div className="card-copy">
            <p>E-commerce Setup</p>
            <p>Payment Gateway Integration</p>
            <p>Inventory Management</p>
            <p>Booking & Scheduling Tools</p>
            <p>Custom Features</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


  </section>  
    </>

  ) : (
  <section className="back-cards">
      <div className="back__cards-header" data-reveal>
      <h1>Services</h1>
    </div>
<div className="back__cards-container">

  {/* Card 1: Website Design */}
 
  
        <div className="card__back-1" data-reveal>
          <div className="card-title">
            <span>Website Design</span>
            <span>01</span>
          </div>
          <div className="card-copy">
            <p>UI/UX Design</p>
            <p>Responsive Layouts</p>
            <p>Wireframes & Prototypes</p>
            <p>Branding Integration</p>
            <p>Visual Storytelling</p>
          </div>
        </div>
     
  

  {/* Card 2: Website Development */}
 
   
        <div className="card__back-2" data-reveal>
          <div className="card-title">
            <span>Website Development</span>
            <span>02</span>
          </div>
          <div className="card-copy">
            <p>Frontend Coding</p>
            <p>Backend Development</p>
            <p>CMS Integration</p>
            <p>SEO Optimization</p>
            <p>Performance Tuning</p>
          </div>
        </div>
     
 
  {/* Card 3: Online Store & Booking Systems */}
 
     
        <div className="card__back-3" data-reveal>
          <div className="card-title">
            <span>Online Store & Booking Systems</span>
            <span>03</span>
          </div>
          <div className="card-copy">
            <p>E-commerce Setup</p>
            <p>Payment Gateway Integration</p>
            <p>Inventory Management</p>
            <p>Booking & Scheduling Tools</p>
            <p>Custom Features</p>
          </div>
        </div>
  
 
</div>


  </section>
  )}


 <CaseStudyGallery/>
  
 
  <WebsiteFAQs/>




</section>

<section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards">
    {/* Carman Autos Ltd */}
    <div className="testimonial-card">
      <p className="quote">
        “Our dealership website is sleek, fast, and easy for customers to browse
        cars. We’ve seen more online inquiries and even closed sales directly
        through the site.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="James Mwangi"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Jorum Ndung'u</p>
          <p className="client-title">Managing Director — Carman Autos Ltd</p>
        </div>
      </div>
    </div>

    {/* Qentrain Solutions */}
    <div className="testimonial-card">
      <p className="quote">
        “Our agribusiness website now acts as a hub for farmers and partners.
        The design is professional and the backend makes it easy for us to
        update market information and services.”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Mercy Wanjiku"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Peter Kahenya  </p>
          <p className="client-title">Founder — Qentrain Solutions</p>
        </div>
      </div>
    </div>

    {/* Syntax by Collins */}
    <div className="testimonial-card">
      <p className="quote">
        “The website beautifully reflects our mission and heart for young people. It communicates purpose, growth, and hope with clarity and warmth."
       </p>
      <div className="client-info">
        <img
          src={testimonial2}
          alt="Collins Otieno"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Dorothy Wawira</p>
          <p className="client-title">Founder — Potters Love Network </p>
        </div>
      </div>
    </div>

    {/* Lozano Films */}
    <div className="testimonial-card">
      <p className="quote">
        “As a director, my website needed to feel cinematic and bold. They
        captured my vision perfectly, now my films and reels have a beautiful
        home online.”
      </p>
      <div className="client-info">
        <img
          src={testimonial3}
          alt="Brian Lozano"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Brian Lozano</p>
          <p className="client-title">Film Director — Lozano Films</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>
  
</>

  )
}

export default Website